export default "__VITE_ASSET__Dp$HK2dL__"